import { GraphQLQueryClass } from "@bsm/component";
import { TUserStudentsResponse } from "@bsm/graphql";

export default class StudentListQuery
    implements GraphQLQueryClass<TUserStudentsResponse, TResponse>
{
    queryKey = "Student.List.Query";

    gql = `
        query StudentListQuery($pageSize: Float, $page: Float, $data: JSONObject, $sort: [TFilterSort!]) {
            userStudents(
                filter: {
                    pageSize: $pageSize,
                    page: $page,
                    data: $data,
                    sort: $sort
                }
            ) {
                total
                data {
                    id
                    studentIdNumber
                    scholarities {
                        id
                        state
                        dateFirstDayAtSchool
                        scholarityClass {
                            id
                            section {
                                id
                                value
                            }
                            class {
                                id
                                value
                            }
                        }
                        schoolScholarity {
                            id
                            state
                            dateBegin
                            dateEnd
                        }
                    }
                    user {
                        id
                        fullName
                        firstName
                        lastName
                        nationality
                        language
                        email
                        dateBirth
                        sexe
                        profilePicture {
                            id
                        }
                    }
                    createdAt
                }
            }
        }

    `;

    variables?: any;

    constructor(variables?: any) {
        this.variables = {
            ...variables,
            data: {
                ...(variables?.data ?? {}),
                registration: {
                    status: 'ACCEPTED'
                }
            }
        };
    }

    mapFn(data: TResponse): TUserStudentsResponse {
        return data.userStudents;
    }
}

type TResponse = { userStudents: TUserStudentsResponse }